export const orderList = {
  print: {
    shippingInstruction: 'Pick',
    deliverySlip: 'SlipA',
    deliveryList: 'SlipB',
    deliveryReceipt: 'SlipC',
  },
}
